import React from "react";
import { bool, string, element, oneOfType, func } from "prop-types";
import Overlay from "../Overlay";
import * as styles from "./style.module.scss";

/* Any padding/margin should be handled within the children themselves */

const Popup = ({
  isOpen,
  handleCloseClick,
  height = "auto",
  children,
  overNav = false,
  classes,
  title,
  padding = "0",
}) => {
  return (
    <Overlay show={isOpen} onOutsideClick={handleCloseClick} overNav={overNav}>
      <div
        className={`bg-white rounded ${classes || ""} ${styles.popup__width}`}
        style={{ height, maxHeight: "90vh", padding }}
      >
        {title && (
          <h4 className={`${styles.popup__title} text-center`}>{title}</h4>
        )}
        {children}
      </div>
    </Overlay>
  );
};

Popup.propTypes = {
  children: oneOfType([element, string]),
  isOpen: bool.isRequired,
  handleCloseClick: func.isRequired,
  height: string,
  classes: string,
  overNav: bool,
  title: string,
  padding: string,
};

export default Popup;
